import * as React from 'react';

import { API_URL, AppConfig, environment, IUser, IUserInfo } from './appConfigContext';

interface IProps {
  children?: React.ReactNode;
}

export const AppConfigProvider: React.FC<IProps> = ({ children }) => {
  const [userInfo, setUserInfo] = React.useState<IUserInfo>();

  const updateUserInfo = (token?: string, user?: IUser) => {
    setUserInfo({
      token,
      user,
    });
  };

  return (
    <AppConfig.Provider
      value={{
        apiUrl: API_URL,
        userInfo,
        updateUserInfo,
        environment,
      }}>
      {children}
    </AppConfig.Provider>
  );
};
